import { render, staticRenderFns } from "./AddOrderMessage.vue?vue&type=template&id=ed75fc52&"
import script from "./AddOrderMessage.vue?vue&type=script&lang=js&"
export * from "./AddOrderMessage.vue?vue&type=script&lang=js&"
import style0 from "./AddOrderMessage.vue?vue&type=style&index=0&id=ed75fc52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports